import React from 'react'
import style from './styles.module.css'
import Topheader from '../../components/Topheader'
export default function CoinDetailsNew() {
  return (
     <>
         <div>
            <Topheader colorbox="newfaq_header_color" title="Detalhes das Fichas"/>
           <div className="top-container container">
             <img
               src={require("../../images/coins-detail/mainbanner.webp")}
               alt="main banner"
               className="img-fluid py-4"
             />
           </div>
           <div className="container">
             <div className="">
               <div className={style.sec2_text1}>
                 O que são Fichas?
               </div>
               <div className={style.sec2_text2}>
                As Fichas são uma moeda que um jogador recebe quando participa de um jogo popular no qual o operador cobra uma comissão por facilitar os serviços do jogo. A taxa de conveniência cobrada em comissão ou rake não está incluída no cálculo das fichas.
               </div>
             </div>
           </div>
            <div className={style.sec3}>
    <div className={style.sec2_text1}>
        Como as Fichas são geradas?
    </div>
    <div className={style.sec3_box}>
         <img
               src={require("../../images/coins-detail/step-2.png")}
               alt="main banner"
               className="img-fluid py-3"
               width={56}
             />
             <div className="">
                <div className={style.sec3_box_text1}>Passo 1: Jogue um Jogo Popular</div>
                 <div className={style.sec3_box_text2}>Toque no ícone na tela inicial para ver todas as recompensas disponíveis.</div>
             </div>
    </div>
     <div className={style.sec3_box}>
         <img
               src={require("../../images/coins-detail/step-1.png")}
               alt="main banner"
               className="img-fluid py-3"
               width={56}

             />
             <div className="">
                <div className={style.sec3_box_text1}>Passo 2: Ganhe Fichas</div>
                 <div className={style.sec3_box_text2}>Ganhe fichas equivalentes ao rake que você gerou enquanto jogava a mão.</div>
             </div>
    </div>
   </div>
         </div>
       </>
  )
}
